import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhendong",
  "use": "icon-zhendong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhendong\"><path d=\"M168 945.984 88 846.016 345.536 640 25.536 383.936 408 78.016 488 177.984 230.464 383.936 550.464 640ZM616 945.984 536 846.016 793.536 640 473.536 383.936 856 78.016 936 177.984 678.464 383.936 998.464 640Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhendong.svg
// module id = Deq/
// module chunks = 11